<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<DeleteConfirmModal
			v-if="type === 'delete'"
			v-model:data="dataDelete"
			@close="closeModal"
			@success="success"
		/>
		<SendData
			v-if="type === 'send'"
			v-model:data="dataProps"
			@close="closeModal"
			@success="success"
			:dayCare="true"
		/>
	</DaModalFrame>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			v-if="sideOverShow"
			@click="sideOverShow = false"
		></div>
		<SideOver
			@close="sideOverShow = false"
			@submit="filterSubmit($event)"
			@cancel="filterSubmit($event)"
			@isFilterDate="isFilterDate = true"
			:staffs="staffs"
			:students="students"
			:isAdmin="isAdmin"
		/>
	</div>
	<div class="__report-lesson px-10 md-down:px-4 pb-30">
		<div
			class="__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl"
			>
				<DaIcon name="das--report" class="mr-3 h-6 w-6" />
				Báo cáo bán trú
			</div>
			<div
				class="w-30 bg-white p-3 rounded-md border shadow-sm border-neutral-200 cursor-pointer flex items-center"
				@click="sideOverShow = true"
			>
				<svg
					width="16"
					height="16"
					viewBox="0 0 16 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M1 3.66797C1 3.11568 1.44772 2.66797 2 2.66797H14C14.5523 2.66797 15 3.11568 15 3.66797C15 4.22025 14.5523 4.66797 14 4.66797H2C1.44772 4.66797 1 4.22025 1 3.66797Z"
						fill="#94A3B8"
					/>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M2.33203 8C2.33203 7.44772 2.77975 7 3.33203 7H12.6654C13.2176 7 13.6654 7.44772 13.6654 8C13.6654 8.55228 13.2176 9 12.6654 9H3.33203C2.77975 9 2.33203 8.55228 2.33203 8Z"
						fill="#94A3B8"
					/>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M4.33203 12C4.33203 11.4477 4.77975 11 5.33203 11H10.6654C11.2176 11 11.6654 11.4477 11.6654 12C11.6654 12.5523 11.2176 13 10.6654 13H5.33203C4.77975 13 4.33203 12.5523 4.33203 12Z"
						fill="#94A3B8"
					/>
				</svg>
				<div class="ml-1.5 font-semibold text-neutral-600">Bộ lọc</div>
			</div>
		</div>
		<div v-if="!isLoading">
			<div class="mb-10" v-if="alertShow">
				<div
					class="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
				>
					<div class="relative">
						<div class="flex items-center gap-4">
							<div>
								<img
									src="@/assets/images/logo/logo.svg"
									alt="luca-logo"
									height="24"
									width="35"
								/>
							</div>
							<div class="pt-1 text-neutral-600 text-sm">
								Dùng nền tảng ứng dụng di động tải về từ
								<a
									href="https://onelink.to/p88838"
									class="underline text-green-500 font-medium"
									>App Store/ CH Play</a
								>
								để tạo và chỉnh sửa báo cáo buổi học
							</div>
						</div>
						<div
							class="top-1 right-2 absolute cursor-pointer"
							@click="alertShow = false"
						>
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
									fill="#E5A42B"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="lessonReports && lessonReports.length > 0"
				class="__report-lesson__container"
				:class="isAdmin ? 'mt-8' : ''"
			>
				<div class="mb-8">
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
						v-if="filter?.state === 'completed'"
					>
						Báo cáo đã hoàn thành
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
							@click="filterSubmit({ state: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
						v-if="filter?.state === 'incompleted'"
					>
						Báo cáo chưa nộp
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
							@click="filterSubmit({ state: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
						v-if="filter?.state === 'cancelled'"
					>
						Báo cáo đã huỷ
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
							@click="filterSubmit({ state: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
						v-if="filter?.date && isFilterDate"
					>
						{{ $filters.formatDate2(filter.date) }}
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
							@click="filterSubmit({ date: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2"
						v-if="filter?.student_id"
					>
						{{
							studentById(filter.student_id)
								? studentById(filter.student_id).name
								: ''
						}}
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900"
							@click="filterSubmit({ student_id: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="text-sm inline-flex items-center py-1 pl-3 pr-2 rounded-full bg-sienna-100 text-neutral-900 mr-2 shadow-input"
						v-if="filter?.staff_id"
					>
						{{
							staffById(filter.staff_id)
								? staffById(filter.staff_id).name
								: ''
						}}
						<button
							type="button"
							class="flex-shrink-0 ml-2 h-4 w-4 rounded-full inline-flex items-center justify-center text-neutral-700 hover:text-neutral-900 shadow-input"
							@click="filterSubmit({ staff_id: '' })"
						>
							<svg
								width="7"
								height="7"
								viewBox="0 0 7 7"
								fill="none"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.35861 0.35861C0.529464 0.187755 0.806474 0.187755 0.977328 0.35861L3.29297 2.67425L5.60861 0.35861C5.77946 0.187755 6.05647 0.187755 6.22733 0.35861C6.39818 0.529464 6.39818 0.806474 6.22733 0.977328L3.91169 3.29297L6.22733 5.60861C6.39818 5.77946 6.39818 6.05647 6.22733 6.22733C6.05647 6.39818 5.77946 6.39818 5.60861 6.22733L3.29297 3.91169L0.977328 6.22733C0.806474 6.39818 0.529464 6.39818 0.35861 6.22733C0.187755 6.05647 0.187755 5.77946 0.35861 5.60861L2.67425 3.29297L0.35861 0.977328C0.187755 0.806474 0.187755 0.529464 0.35861 0.35861Z"
									fill="currentColor"
								/>
							</svg>
						</button>
					</span>
					<span
						class="inline-flex items-center py-0.5 rounded-full ml-2 font-semibold cursor-pointer text-sm text-neutral-500 hover:text-neutral-700"
						v-if="
							filter &&
							Object.keys(filter).length >= 0 &&
							isFilterDate
						"
						@click="filterSubmit(null)"
					>
						Xoá hết bộ lọc
					</span>
				</div>
				<div
					v-for="report in lessonReports"
					:key="report.date"
					class="mb-10"
				>
					<div class="relative mb-3">
						<div
							class="absolute inset-0 flex items-center"
							aria-hidden="true"
						>
							<div
								class="w-full border-t border-gray-300 mb-3.5"
							/>
						</div>
						<div class="relative flex justify-between">
							<div
								class="font-bold text-neutral-600 text-lg mb-3 bg-body pr-3"
							>
								{{ $filters.formatDate2(report.date) }}
							</div>
							<div
								class="bg-body pl-3"
								@click="showHide(report.date)"
							>
								<button
									type="button"
									class="cursor-pointer button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
								>
									<div
										class="mr-1 transform"
										:class="{
											'rotate-180': isHides.includes(
												report.date
											),
										}"
									>
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M15 12.5L10 7.5L5 12.5"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</div>
									<span>{{
										isHides.includes(report.date)
											? 'Mở rộng'
											: 'Thu gọn'
									}}</span>
								</button>
							</div>
						</div>
					</div>
					<div v-if="!isHides.includes(report.date)">
						<div v-if="isAdmin">
							<div
								v-if="report.data.length === 0"
								class="grid gap-8 md-down:gap-4 mb-10 sm-down:grid-cols-1 xl-down:grid-cols-2 grid-cols-4"
								:class="{
									'grid-cols-3':
										filter?.state === 'cancelled',
								}"
							>
								<div
									class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
								>
									<div class="flex items-center flex-nowrap">
										<svg
											width="21"
											height="20"
											viewBox="0 0 21 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g
												clip-path="url(#clip0_1704:5240)"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M1.66797 1.66667C1.66797 0.746192 2.40767 0 3.32014 0H16.5375C17.45 0 18.1897 0.746192 18.1897 1.66667V8.81793C17.4244 8.50542 16.5878 8.33333 15.7114 8.33333C12.0616 8.33333 9.10275 11.25 9.10275 14.9319C9.10275 16.9231 9.96809 18.7784 11.3401 20H3.32014C2.40767 20 1.66797 19.2538 1.66797 18.3333V1.66667ZM2.9071 7.5C2.9071 7.26988 3.09203 7.08333 3.32014 7.08333H11.168C11.3961 7.08333 11.581 7.26988 11.581 7.5C11.581 7.73012 11.3961 7.91667 11.168 7.91667H3.32014C3.09203 7.91667 2.9071 7.73012 2.9071 7.5ZM2.9071 10C2.9071 9.76988 3.09203 9.58333 3.32014 9.58333H9.51579C9.74391 9.58333 9.92884 9.76988 9.92884 10C9.92884 10.2301 9.74391 10.4167 9.51579 10.4167H3.32014C3.09203 10.4167 2.9071 10.2301 2.9071 10ZM2.9071 12.5C2.9071 12.2699 3.09203 12.0833 3.32014 12.0833H7.86362C8.09174 12.0833 8.27666 12.2699 8.27666 12.5C8.27666 12.7301 8.09174 12.9167 7.86362 12.9167H3.32014C3.09203 12.9167 2.9071 12.7301 2.9071 12.5ZM2.9071 15C2.9071 14.7699 3.09203 14.5833 3.32014 14.5833H6.21145C6.43956 14.5833 6.62449 14.7699 6.62449 15C6.62449 15.2301 6.43956 15.4167 6.21145 15.4167H3.32014C3.09203 15.4167 2.9071 15.2301 2.9071 15ZM2.9071 3.75C2.9071 3.28976 3.27695 2.91667 3.73319 2.91667H14.8854C15.3416 2.91667 15.7114 3.28976 15.7114 3.75C15.7114 4.21024 15.3416 4.58333 14.8854 4.58333H3.73319C3.27695 4.58333 2.9071 4.21024 2.9071 3.75Z"
													fill="#2AA797"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M15.7114 20C18.4489 20 20.668 17.7614 20.668 15C20.668 12.2386 18.4489 10 15.7114 10C12.974 10 10.7549 12.2386 10.7549 15C10.7549 17.7614 12.974 20 15.7114 20ZM17.5514 13.106C17.7328 12.923 18.027 12.923 18.2085 13.106C18.3877 13.2869 18.3899 13.5786 18.2151 13.7622L15.7417 16.8811C15.7381 16.8856 15.7343 16.8899 15.7302 16.894C15.5488 17.077 15.2546 17.077 15.0731 16.894L13.4334 15.2399C13.252 15.0569 13.252 14.7601 13.4334 14.577C13.6149 14.394 13.9091 14.394 14.0906 14.577L15.3877 15.8855L17.539 13.1201C17.5429 13.1151 17.547 13.1105 17.5514 13.106Z"
													fill="#2AA797"
												/>
											</g>
											<defs>
												<clipPath id="clip0_1704:5240">
													<rect
														width="20"
														height="20"
														fill="white"
														transform="translate(0.667969)"
													/>
												</clipPath>
											</defs>
										</svg>
										<div
											class="text-neutral-500 text-sm ml-2"
										>
											Báo cáo hoàn thành
										</div>
									</div>
									<div
										class="flex items-center flex-nowrap justify-between"
									>
										<div
											class="text-neutral-600 font-bold text-4xl"
										>
											{{
												report.stats?.completed_count ||
												0
											}}/{{
												report.stats?.total_count || 0
											}}
										</div>
									</div>
								</div>
								<div
									class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
									v-if="filter?.state === 'cancelled'"
								>
									<div class="flex items-center flex-nowrap">
										<svg
											width="21"
											height="20"
											viewBox="0 0 21 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g
												clip-path="url(#clip0_1704:5253)"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z"
													fill="#94A3B8"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z"
													fill="#94A3B8"
												/>
											</g>
											<defs>
												<clipPath id="clip0_1704:5253">
													<rect
														width="20"
														height="20"
														fill="white"
														transform="translate(0.332031)"
													/>
												</clipPath>
											</defs>
										</svg>
										<div
											class="text-neutral-500 text-sm ml-2"
										>
											Báo cáo chưa hoàn thành
										</div>
									</div>
									<div
										class="flex items-center flex-nowrap justify-between"
									>
										<div
											class="text-neutral-600 font-bold text-4xl"
										>
											{{
												report.stats
													?.incomplete_count || 0
											}}
										</div>
									</div>
								</div>
								<div
									class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
									v-if="filter?.state !== 'cancelled'"
								>
									<div class="flex items-center flex-nowrap">
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M2.4987 0C1.57822 0 0.832031 0.746192 0.832031 1.66667V18.3333C0.832031 19.2538 1.57822 20 2.4987 20H10.589C9.20496 18.7784 8.33203 16.9231 8.33203 14.9319C8.33203 11.25 11.3168 8.33333 14.9987 8.33333C15.8828 8.33333 16.7267 8.50542 17.4987 8.81793V1.66667C17.4987 0.746192 16.7525 0 15.832 0H2.4987ZM2.4987 7.08333C2.26858 7.08333 2.08203 7.26988 2.08203 7.5C2.08203 7.73012 2.26858 7.91667 2.4987 7.91667H10.4154C10.6455 7.91667 10.832 7.73012 10.832 7.5C10.832 7.26988 10.6455 7.08333 10.4154 7.08333H2.4987ZM2.4987 9.58333C2.26858 9.58333 2.08203 9.76988 2.08203 10C2.08203 10.2301 2.26858 10.4167 2.4987 10.4167H8.7487C8.97882 10.4167 9.16536 10.2301 9.16536 10C9.16536 9.76988 8.97882 9.58333 8.7487 9.58333H2.4987ZM2.4987 12.0833C2.26858 12.0833 2.08203 12.2699 2.08203 12.5C2.08203 12.7301 2.26858 12.9167 2.4987 12.9167H7.08203C7.31215 12.9167 7.4987 12.7301 7.4987 12.5C7.4987 12.2699 7.31215 12.0833 7.08203 12.0833H2.4987ZM2.4987 14.5833C2.26858 14.5833 2.08203 14.7699 2.08203 15C2.08203 15.2301 2.26858 15.4167 2.4987 15.4167H5.41536C5.64548 15.4167 5.83203 15.2301 5.83203 15C5.83203 14.7699 5.64548 14.5833 5.41536 14.5833H2.4987ZM2.91536 2.91667C2.45513 2.91667 2.08203 3.28976 2.08203 3.75C2.08203 4.21024 2.45513 4.58333 2.91536 4.58333H14.1654C14.6256 4.58333 14.9987 4.21024 14.9987 3.75C14.9987 3.28976 14.6256 2.91667 14.1654 2.91667H2.91536Z"
												fill="#E37056"
											/>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M19.9987 15C19.9987 17.7614 17.7601 20 14.9987 20C12.2373 20 9.9987 17.7614 9.9987 15C9.9987 12.2386 12.2373 10 14.9987 10C17.7601 10 19.9987 12.2386 19.9987 15ZM13.3447 12.904C13.2226 12.782 13.0248 12.782 12.9027 12.904C12.7807 13.0261 12.7807 13.2239 12.9027 13.346L14.5568 15L12.9027 16.654C12.7807 16.7761 12.7807 16.9739 12.9027 17.096C13.0248 17.218 13.2226 17.218 13.3447 17.096L14.9987 15.4419L16.6527 17.096C16.7748 17.218 16.9726 17.218 17.0947 17.096C17.2167 16.9739 17.2167 16.7761 17.0947 16.654L15.4406 15L17.0947 13.346C17.2167 13.2239 17.2167 13.0261 17.0947 12.904C16.9726 12.782 16.7748 12.782 16.6527 12.904L14.9987 14.5581L13.3447 12.904Z"
												fill="#E37056"
											/>
										</svg>

										<div
											class="text-neutral-500 text-sm ml-2"
										>
											Báo cáo đã huỷ
										</div>
									</div>
									<div
										class="flex items-center flex-nowrap justify-between"
									>
										<div
											class="text-neutral-600 font-bold text-4xl"
										>
											{{
												report.cancelled_stats
													?.total_count || 0
											}}
										</div>
									</div>
								</div>
								<div
									class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
									v-if="filter?.state !== 'cancelled'"
								>
									<div class="flex items-center flex-nowrap">
										<svg
											width="21"
											height="20"
											viewBox="0 0 21 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M13.1978 10.0001C13.1978 11.5821 11.9152 12.8647 10.3332 12.8647C8.7511 12.8647 7.46859 11.5821 7.46859 10.0001C7.46859 8.41802 8.7511 7.1355 10.3332 7.1355C11.9152 7.1355 13.1978 8.41802 13.1978 10.0001Z"
												fill="#2AA797"
											/>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M1.1665 10.0001C1.1665 10.0001 4.604 3.698 10.3332 3.698C16.0623 3.698 19.4998 10.0001 19.4998 10.0001C19.4998 10.0001 16.0623 16.3022 10.3332 16.3022C4.604 16.3022 1.1665 10.0001 1.1665 10.0001ZM10.3332 14.0105C12.5481 14.0105 14.3436 12.215 14.3436 10.0001C14.3436 7.78519 12.5481 5.98966 10.3332 5.98966C8.11828 5.98966 6.32275 7.78519 6.32275 10.0001C6.32275 12.215 8.11828 14.0105 10.3332 14.0105Z"
												fill="#2AA797"
											/>
										</svg>
										<div
											class="text-neutral-500 text-sm ml-2"
										>
											PH đã xem
										</div>
									</div>
									<div
										class="flex items-center flex-nowrap justify-between"
									>
										<div
											class="text-neutral-600 font-bold text-4xl"
										>
											{{
												report.stats
													?.numbers_of_parent_read_count ||
												0
											}}
										</div>
									</div>
								</div>
							</div>
							<div
								v-for="(rGroup, index) in report.data"
								:key="index"
								:class="{ 'mt-10': index !== 0 }"
							>
								<div
									class="grid gap-8 md-down:gap-4 mb-10 sm-down:grid-cols-1 xl-down:grid-cols-2 grid-cols-4"
									:class="{
										'grid-cols-3':
											filter?.state === 'cancelled',
									}"
								>
									<div
										class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center"
									>
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M5.99666 20C6.21401 19.9999 6.4291 19.9559 6.62903 19.8706C6.82897 19.7854 7.00964 19.6607 7.16022 19.5039C7.3108 19.3472 7.42819 19.1617 7.50536 18.9585C7.58253 18.7553 7.61788 18.5386 7.60931 18.3214L7.33907 9.88249L8.5167 9.17284C8.8171 8.99077 9.06357 8.73196 9.23077 8.42305C9.39797 8.11413 9.47987 7.76625 9.46803 7.41518L9.23294 0.617447C9.22724 0.453467 9.15807 0.298112 9.04002 0.184158C8.92197 0.0702041 8.76427 0.00656322 8.60019 0.00666215C8.43688 0.00828381 8.28053 0.0729825 8.16383 0.187227C8.04713 0.301471 7.97912 0.456412 7.97402 0.619645L7.80924 4.85559C7.80781 4.98185 7.76112 5.1034 7.67766 5.19815C7.5942 5.2929 7.47951 5.35455 7.35445 5.37191C7.28497 5.37951 7.21467 5.37268 7.14795 5.35184C7.08124 5.33101 7.01954 5.29662 6.96674 5.25082C6.91393 5.20503 6.87116 5.14883 6.84109 5.08573C6.81102 5.02264 6.79431 4.95401 6.792 4.88416L6.62722 0.643812C6.62335 0.498377 6.57147 0.358308 6.47966 0.245442C6.38786 0.132576 6.26129 0.0532551 6.1197 0.0198446C6.03534 0.00562738 5.94919 0.00562738 5.86484 0.0198446C5.72324 0.0532551 5.59667 0.132576 5.50487 0.245442C5.41306 0.358308 5.36118 0.498377 5.35731 0.643812L5.19253 4.88416C5.19022 4.95401 5.17351 5.02264 5.14344 5.08573C5.11337 5.14883 5.0706 5.20503 5.01779 5.25082C4.96499 5.29662 4.9033 5.33101 4.83658 5.35184C4.76986 5.37268 4.69956 5.37951 4.63008 5.37191C4.50502 5.35455 4.39033 5.2929 4.30687 5.19815C4.22341 5.1034 4.17672 4.98185 4.17529 4.85559L4.00392 0.619645C3.99875 0.45336 3.92829 0.295802 3.80781 0.181078C3.68733 0.0663532 3.52652 0.00369344 3.36018 0.00666215C3.1961 0.00656322 3.0384 0.0702041 2.92034 0.184158C2.80229 0.298112 2.73312 0.453467 2.72742 0.617447L2.50112 7.41738C2.48929 7.76844 2.57118 8.11632 2.73838 8.42524C2.90558 8.73416 3.15206 8.99296 3.45245 9.17503L4.65205 9.89567L4.38181 18.3214C4.37323 18.5388 4.40865 18.7557 4.48596 18.959C4.56326 19.1623 4.68085 19.3479 4.83166 19.5047C4.98248 19.6615 5.16341 19.7862 5.36361 19.8713C5.5638 19.9564 5.77913 20.0002 5.99666 20Z"
												fill="#3B82F6"
											/>
											<path
												d="M17.8125 8.24569C18.1252 7.6708 18.287 7.026 18.2827 6.37159C18.2673 4.22065 17.8784 0.0220559 14.7872 8.5179e-05C11.6959 -0.0218855 11.307 4.21187 11.2916 6.37159C11.2866 7.0258 11.4477 7.6706 11.7596 8.24569C12.0901 8.85577 12.5779 9.3663 13.1723 9.72431L13.4623 9.90008L13.1943 18.3214C13.1863 18.5355 13.2216 18.7489 13.298 18.9489C13.3744 19.149 13.4904 19.3316 13.639 19.4858C13.7876 19.64 13.9658 19.7627 14.1629 19.8465C14.3599 19.9303 14.5719 19.9735 14.7861 19.9735C15.0002 19.9735 15.2122 19.9303 15.4093 19.8465C15.6063 19.7627 15.7845 19.64 15.9331 19.4858C16.0817 19.3316 16.1977 19.149 16.2741 18.9489C16.3505 18.7489 16.3858 18.5355 16.3778 18.3214L16.1032 9.89568L16.3932 9.71992C16.9894 9.36403 17.4795 8.855 17.8125 8.24569Z"
												fill="#3B82F6"
											/>
										</svg>
										<div
											class="text-neutral-500 text-sm ml-2 font-semibold"
										>
											{{ rGroup.name }}
										</div>
									</div>
									<div
										class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
									>
										<div
											class="flex items-center flex-nowrap"
										>
											<svg
												width="21"
												height="20"
												viewBox="0 0 21 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<g
													clip-path="url(#clip0_1704:5240)"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M1.66797 1.66667C1.66797 0.746192 2.40767 0 3.32014 0H16.5375C17.45 0 18.1897 0.746192 18.1897 1.66667V8.81793C17.4244 8.50542 16.5878 8.33333 15.7114 8.33333C12.0616 8.33333 9.10275 11.25 9.10275 14.9319C9.10275 16.9231 9.96809 18.7784 11.3401 20H3.32014C2.40767 20 1.66797 19.2538 1.66797 18.3333V1.66667ZM2.9071 7.5C2.9071 7.26988 3.09203 7.08333 3.32014 7.08333H11.168C11.3961 7.08333 11.581 7.26988 11.581 7.5C11.581 7.73012 11.3961 7.91667 11.168 7.91667H3.32014C3.09203 7.91667 2.9071 7.73012 2.9071 7.5ZM2.9071 10C2.9071 9.76988 3.09203 9.58333 3.32014 9.58333H9.51579C9.74391 9.58333 9.92884 9.76988 9.92884 10C9.92884 10.2301 9.74391 10.4167 9.51579 10.4167H3.32014C3.09203 10.4167 2.9071 10.2301 2.9071 10ZM2.9071 12.5C2.9071 12.2699 3.09203 12.0833 3.32014 12.0833H7.86362C8.09174 12.0833 8.27666 12.2699 8.27666 12.5C8.27666 12.7301 8.09174 12.9167 7.86362 12.9167H3.32014C3.09203 12.9167 2.9071 12.7301 2.9071 12.5ZM2.9071 15C2.9071 14.7699 3.09203 14.5833 3.32014 14.5833H6.21145C6.43956 14.5833 6.62449 14.7699 6.62449 15C6.62449 15.2301 6.43956 15.4167 6.21145 15.4167H3.32014C3.09203 15.4167 2.9071 15.2301 2.9071 15ZM2.9071 3.75C2.9071 3.28976 3.27695 2.91667 3.73319 2.91667H14.8854C15.3416 2.91667 15.7114 3.28976 15.7114 3.75C15.7114 4.21024 15.3416 4.58333 14.8854 4.58333H3.73319C3.27695 4.58333 2.9071 4.21024 2.9071 3.75Z"
														fill="#2AA797"
													/>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M15.7114 20C18.4489 20 20.668 17.7614 20.668 15C20.668 12.2386 18.4489 10 15.7114 10C12.974 10 10.7549 12.2386 10.7549 15C10.7549 17.7614 12.974 20 15.7114 20ZM17.5514 13.106C17.7328 12.923 18.027 12.923 18.2085 13.106C18.3877 13.2869 18.3899 13.5786 18.2151 13.7622L15.7417 16.8811C15.7381 16.8856 15.7343 16.8899 15.7302 16.894C15.5488 17.077 15.2546 17.077 15.0731 16.894L13.4334 15.2399C13.252 15.0569 13.252 14.7601 13.4334 14.577C13.6149 14.394 13.9091 14.394 14.0906 14.577L15.3877 15.8855L17.539 13.1201C17.5429 13.1151 17.547 13.1105 17.5514 13.106Z"
														fill="#2AA797"
													/>
												</g>
												<defs>
													<clipPath
														id="clip0_1704:5240"
													>
														<rect
															width="20"
															height="20"
															fill="white"
															transform="translate(0.667969)"
														/>
													</clipPath>
												</defs>
											</svg>
											<div
												class="text-neutral-500 text-sm ml-2"
											>
												Báo cáo hoàn thành
											</div>
										</div>
										<div
											class="flex items-center flex-nowrap justify-between"
										>
											<div
												class="text-neutral-600 font-bold text-4xl"
											>
												{{
													rGroup.stats
														?.completed_count || 0
												}}/{{
													rGroup.stats?.total_count ||
													0
												}}
											</div>
										</div>
									</div>
									<div
										class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
										v-if="filter?.state === 'cancelled'"
									>
										<div
											class="flex items-center flex-nowrap"
										>
											<svg
												width="21"
												height="20"
												viewBox="0 0 21 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<g
													clip-path="url(#clip0_1704:5253)"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z"
														fill="#94A3B8"
													/>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z"
														fill="#94A3B8"
													/>
												</g>
												<defs>
													<clipPath
														id="clip0_1704:5253"
													>
														<rect
															width="20"
															height="20"
															fill="white"
															transform="translate(0.332031)"
														/>
													</clipPath>
												</defs>
											</svg>
											<div
												class="text-neutral-500 text-sm ml-2"
											>
												Báo cáo chưa hoàn thành
											</div>
										</div>
										<div
											class="flex items-center flex-nowrap justify-between"
										>
											<div
												class="text-neutral-600 font-bold text-4xl"
											>
												{{
													rGroup.stats
														?.incomplete_count || 0
												}}
											</div>
										</div>
									</div>
									<div
										class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
										v-if="filter?.state !== 'cancelled'"
									>
										<div
											class="flex items-center flex-nowrap"
										>
											<svg
												width="20"
												height="20"
												viewBox="0 0 20 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M2.4987 0C1.57822 0 0.832031 0.746192 0.832031 1.66667V18.3333C0.832031 19.2538 1.57822 20 2.4987 20H10.589C9.20496 18.7784 8.33203 16.9231 8.33203 14.9319C8.33203 11.25 11.3168 8.33333 14.9987 8.33333C15.8828 8.33333 16.7267 8.50542 17.4987 8.81793V1.66667C17.4987 0.746192 16.7525 0 15.832 0H2.4987ZM2.4987 7.08333C2.26858 7.08333 2.08203 7.26988 2.08203 7.5C2.08203 7.73012 2.26858 7.91667 2.4987 7.91667H10.4154C10.6455 7.91667 10.832 7.73012 10.832 7.5C10.832 7.26988 10.6455 7.08333 10.4154 7.08333H2.4987ZM2.4987 9.58333C2.26858 9.58333 2.08203 9.76988 2.08203 10C2.08203 10.2301 2.26858 10.4167 2.4987 10.4167H8.7487C8.97882 10.4167 9.16536 10.2301 9.16536 10C9.16536 9.76988 8.97882 9.58333 8.7487 9.58333H2.4987ZM2.4987 12.0833C2.26858 12.0833 2.08203 12.2699 2.08203 12.5C2.08203 12.7301 2.26858 12.9167 2.4987 12.9167H7.08203C7.31215 12.9167 7.4987 12.7301 7.4987 12.5C7.4987 12.2699 7.31215 12.0833 7.08203 12.0833H2.4987ZM2.4987 14.5833C2.26858 14.5833 2.08203 14.7699 2.08203 15C2.08203 15.2301 2.26858 15.4167 2.4987 15.4167H5.41536C5.64548 15.4167 5.83203 15.2301 5.83203 15C5.83203 14.7699 5.64548 14.5833 5.41536 14.5833H2.4987ZM2.91536 2.91667C2.45513 2.91667 2.08203 3.28976 2.08203 3.75C2.08203 4.21024 2.45513 4.58333 2.91536 4.58333H14.1654C14.6256 4.58333 14.9987 4.21024 14.9987 3.75C14.9987 3.28976 14.6256 2.91667 14.1654 2.91667H2.91536Z"
													fill="#E37056"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M19.9987 15C19.9987 17.7614 17.7601 20 14.9987 20C12.2373 20 9.9987 17.7614 9.9987 15C9.9987 12.2386 12.2373 10 14.9987 10C17.7601 10 19.9987 12.2386 19.9987 15ZM13.3447 12.904C13.2226 12.782 13.0248 12.782 12.9027 12.904C12.7807 13.0261 12.7807 13.2239 12.9027 13.346L14.5568 15L12.9027 16.654C12.7807 16.7761 12.7807 16.9739 12.9027 17.096C13.0248 17.218 13.2226 17.218 13.3447 17.096L14.9987 15.4419L16.6527 17.096C16.7748 17.218 16.9726 17.218 17.0947 17.096C17.2167 16.9739 17.2167 16.7761 17.0947 16.654L15.4406 15L17.0947 13.346C17.2167 13.2239 17.2167 13.0261 17.0947 12.904C16.9726 12.782 16.7748 12.782 16.6527 12.904L14.9987 14.5581L13.3447 12.904Z"
													fill="#E37056"
												/>
											</svg>

											<div
												class="text-neutral-500 text-sm ml-2"
											>
												Báo cáo đã huỷ
											</div>
										</div>
										<div
											class="flex items-center flex-nowrap justify-between"
										>
											<div
												class="text-neutral-600 font-bold text-4xl"
											>
												{{
													rGroup.stats
														?.incomplete_count || 0
												}}
											</div>
										</div>
									</div>
									<div
										class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
										v-if="filter?.state !== 'cancelled'"
									>
										<div
											class="flex items-center flex-nowrap"
										>
											<svg
												width="21"
												height="20"
												viewBox="0 0 21 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M13.1978 10.0001C13.1978 11.5821 11.9152 12.8647 10.3332 12.8647C8.7511 12.8647 7.46859 11.5821 7.46859 10.0001C7.46859 8.41802 8.7511 7.1355 10.3332 7.1355C11.9152 7.1355 13.1978 8.41802 13.1978 10.0001Z"
													fill="#2AA797"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M1.1665 10.0001C1.1665 10.0001 4.604 3.698 10.3332 3.698C16.0623 3.698 19.4998 10.0001 19.4998 10.0001C19.4998 10.0001 16.0623 16.3022 10.3332 16.3022C4.604 16.3022 1.1665 10.0001 1.1665 10.0001ZM10.3332 14.0105C12.5481 14.0105 14.3436 12.215 14.3436 10.0001C14.3436 7.78519 12.5481 5.98966 10.3332 5.98966C8.11828 5.98966 6.32275 7.78519 6.32275 10.0001C6.32275 12.215 8.11828 14.0105 10.3332 14.0105Z"
													fill="#2AA797"
												/>
											</svg>
											<div
												class="text-neutral-500 text-sm ml-2"
											>
												PH đã xem
											</div>
										</div>
										<div
											class="flex items-center flex-nowrap justify-between"
										>
											<div
												class="text-neutral-600 font-bold text-4xl"
											>
												{{
													rGroup.stats
														?.numbers_of_parent_read_count ||
													0
												}}
											</div>
										</div>
									</div>
								</div>
								<div
									class="shadow-sm sm:rounded-2xl overflow-x-auto"
								>
									<div class="shadow-sm sm:rounded-2xl">
										<div class="__record__table scroll-bar">
											<div
												class="sm:rounded-t-2xl w-fit min-w-full"
											>
												<table
													class="min-w-full divide-y text-neutral-200 rounded-2xl"
												>
													<thead
														class="bg-neutral-100 h-16"
													>
														<tr>
															<th
																scope="col"
																class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-32 whitespace-nowrap"
															>
																Tên học sinh
															</th>
															<th
																scope="col"
																class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
															>
																Sức khoẻ
															</th>
															<th
																scope="col"
																class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
															>
																Giấc ngủ
															</th>
															<th
																scope="col"
																class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
															>
																Ăn uống
															</th>
															<th
																scope="col"
																class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
															>
																nhận xét buổi
																học
															</th>
															<th
																scope="col"
																class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
															>
																cảm xúc
															</th>
															<th
																scope="col"
																class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
															>
																điểm danh
															</th>
															<th
																scope="col"
																class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
															>
																Trạng thái
															</th>
															<th
																scope="col"
																class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
															>
																Gửi tới PH
															</th>
															<th
																scope="col"
																class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
															>
																PH ĐÃ XEM
															</th>
															<th
																scope="col"
																class="px-3 py-3 w-12 tracking-wider whitespace-nowrap"
															></th>
														</tr>
													</thead>
													<tbody>
														<tr
															@click="
																![
																	'new',
																	'created',
																].includes(
																	item.state
																) &&
																	$router.push(
																		`/report/day-care/${report.date}?student_id=${item?.student?.id}`
																	)
															"
															v-for="(
																item, index
															) in rGroup.reports"
															:key="item.id"
															:class="[
																index % 2 === 0
																	? 'bg-white'
																	: 'bg-neutral-50',
																![
																	'new',
																	'created',
																].includes(
																	item.state
																)
																	? 'cursor-pointer'
																	: '',
															]"
															class="text-neutral-700 hover:bg-orange-50 cursor-pointer"
														>
															<td
																class="px-3 py-4 whitespace-nowrap text-neutral-700"
															>
																<div
																	style="
																		width: 200px;
																	"
																	class="flex items-center"
																>
																	<img
																		class="shadow-sm inline-block h-6 w-6 rounded-full"
																		:src="
																			item
																				?.student
																				?.profile_photo
																				?.w200
																		"
																		v-if="
																			item
																				?.student
																				?.profile_photo
																				?.w200
																		"
																		alt=""
																	/>
																	<span
																		v-else
																		class="inline-flex items-center justify-center h-6 w-6 rounded-full"
																		:style="{
																			background:
																				item
																					?.student
																					?.profile_photo
																					?.default
																					?.color,
																		}"
																	>
																		<span
																			class="text-xs font-medium leading-none text-white"
																			>{{
																				item
																					?.student
																					?.profile_photo
																					?.default
																					?.initial
																			}}</span
																		>
																	</span>
																	<div
																		class="ml-4 font-semibold text-orange-600 truncate"
																	>
																		{{
																			item
																				?.student
																				?.name
																		}}
																	</div>
																</div>
															</td>
															<td>
																<div
																	style="
																		width: 100px;
																	"
																	class="px-3 py-4 capitalize whitespace-nowrap"
																	:class="{
																		'text-red-500':
																			item?.day_care_health ===
																			'unwell',
																	}"
																>
																	{{
																		item?.translated_day_care_health
																	}}
																</div>
															</td>
															<td>
																<div
																	style="
																		width: 100px;
																	"
																	class="px-3 py-4 capitalize whitespace-nowrap"
																	:class="{
																		'text-red-500':
																			item?.day_care_sleep ===
																			'none',
																	}"
																>
																	{{
																		item?.translated_day_care_sleep
																	}}
																</div>
															</td>
															<td>
																<div
																	class="px-3 py-4 capitalize whitespace-nowrap"
																>
																	<div
																		v-if="
																			enabledMenu
																		"
																	>
																		<div
																			v-for="meal in item?.day_care_eats"
																			:key="
																				meal.id
																			"
																		>
																			{{
																				meal.meal_name
																			}}:
																			{{
																				meal.translated_day_care_eat
																			}}
																		</div>
																	</div>
																	<div
																		v-else
																		:class="{
																			'text-red-500':
																				item?.day_care_sleep ===
																				'none',
																		}"
																	>
																		{{
																			item?.translated_day_care_eat
																		}}
																	</div>
																</div>
															</td>
															<td>
																<div
																	class="px-3 py-4"
																	style="
																		max-width: 140px;
																		margin-right: 40px;
																	"
																>
																	<Rating
																		:rating="
																			item?.day_care_scale
																		"
																	/>
																</div>
															</td>
															<td>
																<div
																	class="px-3 py-4"
																>
																	<img
																		v-if="
																			item?.emotion_scale
																		"
																		:src="
																			require(`@/assets/images/emoji/${
																				$filters.emoji(
																					item?.emotion_scale +
																						''
																				)
																					.emoji
																			}`)
																		"
																		alt=""
																		class="h-6 w-6"
																	/>
																</div>
															</td>
															<td
																style="
																	min-width: 115px;
																"
																class="px-3 py-4 capitalize whitespace-nowrap"
															>
																<div
																	class="flex items-center gap-2"
																>
																	<img
																		v-if="
																			item
																				?.checkin
																				?.display_media_timestamp ||
																			item
																				?.checkin
																				?.display_time
																		"
																		src="@/assets/images/icons/checkin.png"
																		alt=""
																	/>
																	<img
																		v-else
																		src="@/assets/images/icons/disabled-checkin.png"
																		alt=""
																	/>
																	<div
																		v-if="
																			item
																				?.checkin
																				?.display_media_timestamp ||
																			item
																				?.checkin
																				?.display_time
																		"
																	>
																		{{
																			item
																				?.checkin
																				?.display_media_timestamp ||
																			item
																				?.checkin
																				?.display_time
																		}}
																	</div>
																	<div v-else>
																		-
																	</div>
																	<img
																		v-if="
																			item
																				?.checkin
																				?.sent_at
																		"
																		src="@/assets/images/icons/has_taught.png"
																		alt=""
																	/>
																</div>
																<div
																	class="flex items-center gap-2"
																>
																	<img
																		v-if="
																			item
																				?.checkout
																				?.display_media_timestamp ||
																			item
																				?.checkout
																				?.display_time
																		"
																		src="@/assets/images/icons/checkout.png"
																		alt=""
																	/>
																	<img
																		v-else
																		src="@/assets/images/icons/disabled-checkout.png"
																		alt=""
																	/>
																	<div
																		v-if="
																			item
																				?.checkout
																				?.display_media_timestamp ||
																			item
																				?.checkout
																				?.display_time
																		"
																	>
																		{{
																			item
																				?.checkout
																				?.display_media_timestamp ||
																			item
																				?.checkout
																				?.display_time
																		}}
																	</div>
																	<div v-else>
																		-
																	</div>
																	<img
																		v-if="
																			item
																				?.checkout
																				?.sent_at
																		"
																		src="@/assets/images/icons/has_taught.png"
																		alt=""
																	/>
																</div>
															</td>
															<td
																class="px-3 py-4 whitespace-nowrap text-neutral-700"
															>
																<div
																	class="ml-6"
																>
																	<svg
																		width="21"
																		height="20"
																		viewBox="0 0 21 20"
																		fill="none"
																		xmlns="http://www.w3.org/2000/svg"
																		v-if="
																			item?.state ===
																			'completed'
																		"
																	>
																		<g
																			clip-path="url(#clip0_1706:5649)"
																		>
																			<path
																				fill-rule="evenodd"
																				clip-rule="evenodd"
																				d="M1.5 1.66667C1.5 0.746192 2.2397 0 3.15217 0H16.3696C17.282 0 18.0217 0.746192 18.0217 1.66667V8.81793C17.2564 8.50542 16.4199 8.33333 15.5435 8.33333C11.8936 8.33333 8.93478 11.25 8.93478 14.9319C8.93478 16.9231 9.80012 18.7784 11.1721 20H3.15217C2.2397 20 1.5 19.2538 1.5 18.3333V1.66667ZM2.73913 7.5C2.73913 7.26988 2.92406 7.08333 3.15217 7.08333H11C11.2281 7.08333 11.413 7.26988 11.413 7.5C11.413 7.73012 11.2281 7.91667 11 7.91667H3.15217C2.92406 7.91667 2.73913 7.73012 2.73913 7.5ZM2.73913 10C2.73913 9.76988 2.92406 9.58333 3.15217 9.58333H9.34783C9.57594 9.58333 9.76087 9.76988 9.76087 10C9.76087 10.2301 9.57594 10.4167 9.34783 10.4167H3.15217C2.92406 10.4167 2.73913 10.2301 2.73913 10ZM2.73913 12.5C2.73913 12.2699 2.92406 12.0833 3.15217 12.0833H7.69565C7.92377 12.0833 8.1087 12.2699 8.1087 12.5C8.1087 12.7301 7.92377 12.9167 7.69565 12.9167H3.15217C2.92406 12.9167 2.73913 12.7301 2.73913 12.5ZM2.73913 15C2.73913 14.7699 2.92406 14.5833 3.15217 14.5833H6.04348C6.2716 14.5833 6.45652 14.7699 6.45652 15C6.45652 15.2301 6.2716 15.4167 6.04348 15.4167H3.15217C2.92406 15.4167 2.73913 15.2301 2.73913 15ZM2.73913 3.75C2.73913 3.28976 3.10898 2.91667 3.56522 2.91667H14.7174C15.1736 2.91667 15.5435 3.28976 15.5435 3.75C15.5435 4.21024 15.1736 4.58333 14.7174 4.58333H3.56522C3.10898 4.58333 2.73913 4.21024 2.73913 3.75Z"
																				fill="#2AA797"
																			/>
																			<path
																				fill-rule="evenodd"
																				clip-rule="evenodd"
																				d="M15.5435 20C18.2809 20 20.5 17.7614 20.5 15C20.5 12.2386 18.2809 10 15.5435 10C12.8061 10 10.587 12.2386 10.587 15C10.587 17.7614 12.8061 20 15.5435 20ZM17.3834 13.106C17.5649 12.923 17.8591 12.923 18.0405 13.106C18.2198 13.2869 18.222 13.5786 18.0471 13.7622L15.5737 16.8811C15.5701 16.8856 15.5663 16.8899 15.5623 16.894C15.3808 17.077 15.0866 17.077 14.9051 16.894L13.2655 15.2399C13.084 15.0569 13.084 14.7601 13.2655 14.577C13.4469 14.394 13.7412 14.394 13.9226 14.577L15.2197 15.8855L17.3711 13.1201C17.3749 13.1151 17.379 13.1105 17.3834 13.106Z"
																				fill="#2AA797"
																			/>
																		</g>
																		<defs>
																			<clipPath
																				id="clip0_1706:5649"
																			>
																				<rect
																					width="20"
																					height="20"
																					fill="white"
																					transform="translate(0.5)"
																				/>
																			</clipPath>
																		</defs>
																	</svg>
																	<svg
																		width="21"
																		height="20"
																		viewBox="0 0 21 20"
																		fill="none"
																		xmlns="http://www.w3.org/2000/svg"
																		v-else-if="
																			item.state ===
																			'cancelled'
																		"
																	>
																		<g
																			clip-path="url(#clip0_1739:6086)"
																		>
																			<path
																				fill-rule="evenodd"
																				clip-rule="evenodd"
																				d="M2.9987 0C2.07822 0 1.33203 0.746192 1.33203 1.66667V18.3333C1.33203 19.2538 2.07822 20 2.9987 20H11.089C9.70496 18.7784 8.83203 16.9231 8.83203 14.9319C8.83203 11.25 11.8168 8.33333 15.4987 8.33333C16.3828 8.33333 17.2267 8.50542 17.9987 8.81793V1.66667C17.9987 0.746192 17.2525 0 16.332 0H2.9987ZM2.9987 7.08333C2.76858 7.08333 2.58203 7.26988 2.58203 7.5C2.58203 7.73012 2.76858 7.91667 2.9987 7.91667H10.9154C11.1455 7.91667 11.332 7.73012 11.332 7.5C11.332 7.26988 11.1455 7.08333 10.9154 7.08333H2.9987ZM2.9987 9.58333C2.76858 9.58333 2.58203 9.76988 2.58203 10C2.58203 10.2301 2.76858 10.4167 2.9987 10.4167H9.2487C9.47882 10.4167 9.66536 10.2301 9.66536 10C9.66536 9.76988 9.47882 9.58333 9.2487 9.58333H2.9987ZM2.9987 12.0833C2.76858 12.0833 2.58203 12.2699 2.58203 12.5C2.58203 12.7301 2.76858 12.9167 2.9987 12.9167H7.58203C7.81215 12.9167 7.9987 12.7301 7.9987 12.5C7.9987 12.2699 7.81215 12.0833 7.58203 12.0833H2.9987ZM2.9987 14.5833C2.76858 14.5833 2.58203 14.7699 2.58203 15C2.58203 15.2301 2.76858 15.4167 2.9987 15.4167H5.91536C6.14548 15.4167 6.33203 15.2301 6.33203 15C6.33203 14.7699 6.14548 14.5833 5.91536 14.5833H2.9987ZM3.41536 2.91667C2.95513 2.91667 2.58203 3.28976 2.58203 3.75C2.58203 4.21024 2.95513 4.58333 3.41536 4.58333H14.6654C15.1256 4.58333 15.4987 4.21024 15.4987 3.75C15.4987 3.28976 15.1256 2.91667 14.6654 2.91667H3.41536Z"
																				fill="#E37056"
																			/>
																			<path
																				fill-rule="evenodd"
																				clip-rule="evenodd"
																				d="M20.4987 15C20.4987 17.7614 18.2601 20 15.4987 20C12.7373 20 10.4987 17.7614 10.4987 15C10.4987 12.2386 12.7373 10 15.4987 10C18.2601 10 20.4987 12.2386 20.4987 15ZM13.8447 12.904C13.7226 12.782 13.5248 12.782 13.4027 12.904C13.2807 13.0261 13.2807 13.2239 13.4027 13.346L15.0568 15L13.4027 16.654C13.2807 16.7761 13.2807 16.9739 13.4027 17.096C13.5248 17.218 13.7226 17.218 13.8447 17.096L15.4987 15.4419L17.1527 17.096C17.2748 17.218 17.4726 17.218 17.5947 17.096C17.7167 16.9739 17.7167 16.7761 17.5947 16.654L15.9406 15L17.5947 13.346C17.7167 13.2239 17.7167 13.0261 17.5947 12.904C17.4726 12.782 17.2748 12.782 17.1527 12.904L15.4987 14.5581L13.8447 12.904Z"
																				fill="#E37056"
																			/>
																		</g>
																		<defs>
																			<clipPath
																				id="clip0_1739:6086"
																			>
																				<rect
																					width="20"
																					height="20"
																					fill="white"
																					transform="translate(0.5)"
																				/>
																			</clipPath>
																		</defs>
																	</svg>
																	<svg
																		width="21"
																		height="20"
																		viewBox="0 0 21 20"
																		fill="none"
																		xmlns="http://www.w3.org/2000/svg"
																		v-else
																	>
																		<g
																			clip-path="url(#clip0_1739:6086)"
																		>
																			<path
																				fill-rule="evenodd"
																				clip-rule="evenodd"
																				d="M2.9987 0C2.07822 0 1.33203 0.746192 1.33203 1.66667V18.3333C1.33203 19.2538 2.07822 20 2.9987 20H11.089C9.70496 18.7784 8.83203 16.9231 8.83203 14.9319C8.83203 11.25 11.8168 8.33333 15.4987 8.33333C16.3828 8.33333 17.2267 8.50542 17.9987 8.81793V1.66667C17.9987 0.746192 17.2525 0 16.332 0H2.9987ZM2.9987 7.08333C2.76858 7.08333 2.58203 7.26988 2.58203 7.5C2.58203 7.73012 2.76858 7.91667 2.9987 7.91667H10.9154C11.1455 7.91667 11.332 7.73012 11.332 7.5C11.332 7.26988 11.1455 7.08333 10.9154 7.08333H2.9987ZM2.9987 9.58333C2.76858 9.58333 2.58203 9.76988 2.58203 10C2.58203 10.2301 2.76858 10.4167 2.9987 10.4167H9.2487C9.47882 10.4167 9.66536 10.2301 9.66536 10C9.66536 9.76988 9.47882 9.58333 9.2487 9.58333H2.9987ZM2.9987 12.0833C2.76858 12.0833 2.58203 12.2699 2.58203 12.5C2.58203 12.7301 2.76858 12.9167 2.9987 12.9167H7.58203C7.81215 12.9167 7.9987 12.7301 7.9987 12.5C7.9987 12.2699 7.81215 12.0833 7.58203 12.0833H2.9987ZM2.9987 14.5833C2.76858 14.5833 2.58203 14.7699 2.58203 15C2.58203 15.2301 2.76858 15.4167 2.9987 15.4167H5.91536C6.14548 15.4167 6.33203 15.2301 6.33203 15C6.33203 14.7699 6.14548 14.5833 5.91536 14.5833H2.9987ZM3.41536 2.91667C2.95513 2.91667 2.58203 3.28976 2.58203 3.75C2.58203 4.21024 2.95513 4.58333 3.41536 4.58333H14.6654C15.1256 4.58333 15.4987 4.21024 15.4987 3.75C15.4987 3.28976 15.1256 2.91667 14.6654 2.91667H3.41536Z"
																				fill="#94A3B8"
																			/>
																			<path
																				fill-rule="evenodd"
																				clip-rule="evenodd"
																				d="M20.4987 15C20.4987 17.7614 18.2601 20 15.4987 20C12.7373 20 10.4987 17.7614 10.4987 15C10.4987 12.2386 12.7373 10 15.4987 10C18.2601 10 20.4987 12.2386 20.4987 15ZM13.8447 12.904C13.7226 12.782 13.5248 12.782 13.4027 12.904C13.2807 13.0261 13.2807 13.2239 13.4027 13.346L15.0568 15L13.4027 16.654C13.2807 16.7761 13.2807 16.9739 13.4027 17.096C13.5248 17.218 13.7226 17.218 13.8447 17.096L15.4987 15.4419L17.1527 17.096C17.2748 17.218 17.4726 17.218 17.5947 17.096C17.7167 16.9739 17.7167 16.7761 17.5947 16.654L15.9406 15L17.5947 13.346C17.7167 13.2239 17.7167 13.0261 17.5947 12.904C17.4726 12.782 17.2748 12.782 17.1527 12.904L15.4987 14.5581L13.8447 12.904Z"
																				fill="#94A3B8"
																			/>
																		</g>
																		<defs>
																			<clipPath
																				id="clip0_1739:6086"
																			>
																				<rect
																					width="20"
																					height="20"
																					fill="white"
																					transform="translate(0.5)"
																				/>
																			</clipPath>
																		</defs>
																	</svg>
																</div>
															</td>
															<td
																class="px-3 py-4 whitespace-nowrap text-neutral-700"
															>
																<button
																	v-if="
																		item.state ===
																			'completed' &&
																		!item.sent_at &&
																		!org?.enable_day_care_report_sent
																	"
																	@click.stop="
																		sendReport(
																			item
																		)
																	"
																	type="button"
																	class="button-p text-center whitespace-nowrap w-fit btn--ghost"
																>
																	Gửi báo cáo
																</button>
																<span v-else>
																	{{
																		item.sent_at
																			? 'Đã gửi'
																			: '-'
																	}}
																</span>
															</td>
															<td>
																<div
																	style="
																		width: 100px;
																	"
																	class="px-3 py-4 capitalize whitespace-nowrap"
																>
																	{{
																		item.numbers_of_parent_read
																	}}/
																	{{
																		item.total_parent_count
																	}}
																</div>
															</td>
															<td
																class="w-12 px-3 py-4"
															>
																<Menu
																	as="div"
																	class="relative"
																>
																	<div>
																		<MenuButton
																			@click.stop="
																				setReportMenuPosition
																			"
																			class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
																		>
																			<span
																				class="sr-only"
																				>Open
																				user
																				menu</span
																			>
																			<svg
																				width="20"
																				height="20"
																				viewBox="0 0 20 20"
																				fill="none"
																				xmlns="http://www.w3.org/2000/svg"
																			>
																				<path
																					fill-rule="evenodd"
																					clip-rule="evenodd"
																					d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
																					fill="#94A3B8"
																				/>
																			</svg>
																		</MenuButton>
																	</div>
																	<teleport
																		to="body"
																	>
																		<transition
																			enter-active-class="transition ease-out duration-200"
																			enter-from-class="transform opacity-0 scale-95"
																			enter-to-class="transform opacity-100 scale-100"
																			leave-active-class="transition ease-in duration-75"
																			leave-from-class="transform opacity-100 scale-100"
																			leave-to-class="transform opacity-0 scale-95"
																		>
																			<MenuItems
																				:style="
																					reportMenuStyle
																				"
																				class="origin-top-right fixed z-50 w-80 rounded-md py-1 bg-white focus:outline-none shadow-sm"
																			>
																				<MenuItem
																					v-if="
																						((item?.checkin &&
																							!item
																								?.checkin
																								.sent_at) ||
																							(item?.checkout &&
																								!item
																									?.checkout
																									?.sent_at)) &&
																						flagCheck()
																					"
																				>
																					<div
																						class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																						@click.stop="
																							openSendData(
																								item
																							)
																						"
																					>
																						<img
																							src="@/assets/images/icons/send.png"
																							alt=""
																						/>
																						<div>
																							Gửi
																							điểm
																							danh
																							tới
																							PH
																						</div>
																					</div>
																				</MenuItem>
																				<MenuItem>
																					<div
																						v-if="
																							filter?.state !==
																							'cancelled'
																						"
																						@click.stop="
																							openDeleteConfirm(
																								item
																							)
																						"
																						class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																					>
																						<svg
																							width="16"
																							height="16"
																							viewBox="0 0 16 16"
																							fill="none"
																							xmlns="http://www.w3.org/2000/svg"
																						>
																							<path
																								fill-rule="evenodd"
																								clip-rule="evenodd"
																								d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
																								fill="#94A3B8"
																							/>
																						</svg>
																						<span
																							class="mt-0.5"
																							>Xoá
																							báo
																							cáo</span
																						>
																					</div>
																					<div
																						v-else
																						@click.stop="
																							recoverReport(
																								item.id
																							)
																						"
																						class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																					>
																						<svg
																							width="16"
																							height="12"
																							viewBox="0 0 16 12"
																							fill="none"
																							xmlns="http://www.w3.org/2000/svg"
																						>
																							<path
																								d="M11.5356 5H15.4681C15.6801 5 15.7959 5.24721 15.6602 5.41005L13.6939 7.76953C13.594 7.88947 13.4098 7.88947 13.3098 7.76953L11.3436 5.41005C11.2079 5.24721 11.3237 5 11.5356 5Z"
																								fill="#94A3B8"
																							/>
																							<path
																								d="M0.535634 7H4.46811C4.68007 7 4.79586 6.75279 4.66017 6.58995L2.69393 4.23047C2.59398 4.11053 2.40977 4.11053 2.30982 4.23047L0.343579 6.58995C0.207886 6.75279 0.323675 7 0.535634 7Z"
																								fill="#94A3B8"
																							/>
																							<path
																								fill-rule="evenodd"
																								clip-rule="evenodd"
																								d="M8.00188 1C6.44938 1 5.06244 1.70697 4.14456 2.81839C3.96872 3.03131 3.65357 3.06137 3.44065 2.88552C3.22773 2.70968 3.19767 2.39453 3.37351 2.18161C4.47322 0.850027 6.13849 0 8.00188 0C10.9436 0 13.3899 2.1165 13.903 4.90967C13.9085 4.9397 13.9138 4.96981 13.9188 5H12.902C12.4389 2.71778 10.4205 1 8.00188 1ZM3.10179 7C3.5648 9.28222 5.58325 11 8.00188 11C9.55437 11 10.9413 10.293 11.8592 9.18161C12.035 8.96869 12.3502 8.93863 12.5631 9.11448C12.776 9.29032 12.8061 9.60547 12.6302 9.81839C11.5305 11.15 9.86526 12 8.00188 12C5.06017 12 2.61385 9.8835 2.10079 7.09033C2.09527 7.0603 2.08998 7.03019 2.08491 7H3.10179Z"
																								fill="#94A3B8"
																							/>
																						</svg>

																						<span
																							class="mt-0.5"
																							>Khôi
																							phục
																							báo
																							cáo</span
																						>
																					</div>
																				</MenuItem>
																			</MenuItems>
																		</transition>
																	</teleport>
																</Menu>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-else>
							<div
								class="grid gap-8 md-down:gap-4 mb-10 sm-down:grid-cols-1 md-down:grid-cols-2 grid-cols-4"
							>
								<div
									class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
								>
									<div class="flex items-center flex-nowrap">
										<svg
											width="21"
											height="20"
											viewBox="0 0 21 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g
												clip-path="url(#clip0_1704:5240)"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M1.66797 1.66667C1.66797 0.746192 2.40767 0 3.32014 0H16.5375C17.45 0 18.1897 0.746192 18.1897 1.66667V8.81793C17.4244 8.50542 16.5878 8.33333 15.7114 8.33333C12.0616 8.33333 9.10275 11.25 9.10275 14.9319C9.10275 16.9231 9.96809 18.7784 11.3401 20H3.32014C2.40767 20 1.66797 19.2538 1.66797 18.3333V1.66667ZM2.9071 7.5C2.9071 7.26988 3.09203 7.08333 3.32014 7.08333H11.168C11.3961 7.08333 11.581 7.26988 11.581 7.5C11.581 7.73012 11.3961 7.91667 11.168 7.91667H3.32014C3.09203 7.91667 2.9071 7.73012 2.9071 7.5ZM2.9071 10C2.9071 9.76988 3.09203 9.58333 3.32014 9.58333H9.51579C9.74391 9.58333 9.92884 9.76988 9.92884 10C9.92884 10.2301 9.74391 10.4167 9.51579 10.4167H3.32014C3.09203 10.4167 2.9071 10.2301 2.9071 10ZM2.9071 12.5C2.9071 12.2699 3.09203 12.0833 3.32014 12.0833H7.86362C8.09174 12.0833 8.27666 12.2699 8.27666 12.5C8.27666 12.7301 8.09174 12.9167 7.86362 12.9167H3.32014C3.09203 12.9167 2.9071 12.7301 2.9071 12.5ZM2.9071 15C2.9071 14.7699 3.09203 14.5833 3.32014 14.5833H6.21145C6.43956 14.5833 6.62449 14.7699 6.62449 15C6.62449 15.2301 6.43956 15.4167 6.21145 15.4167H3.32014C3.09203 15.4167 2.9071 15.2301 2.9071 15ZM2.9071 3.75C2.9071 3.28976 3.27695 2.91667 3.73319 2.91667H14.8854C15.3416 2.91667 15.7114 3.28976 15.7114 3.75C15.7114 4.21024 15.3416 4.58333 14.8854 4.58333H3.73319C3.27695 4.58333 2.9071 4.21024 2.9071 3.75Z"
													fill="#2AA797"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M15.7114 20C18.4489 20 20.668 17.7614 20.668 15C20.668 12.2386 18.4489 10 15.7114 10C12.974 10 10.7549 12.2386 10.7549 15C10.7549 17.7614 12.974 20 15.7114 20ZM17.5514 13.106C17.7328 12.923 18.027 12.923 18.2085 13.106C18.3877 13.2869 18.3899 13.5786 18.2151 13.7622L15.7417 16.8811C15.7381 16.8856 15.7343 16.8899 15.7302 16.894C15.5488 17.077 15.2546 17.077 15.0731 16.894L13.4334 15.2399C13.252 15.0569 13.252 14.7601 13.4334 14.577C13.6149 14.394 13.9091 14.394 14.0906 14.577L15.3877 15.8855L17.539 13.1201C17.5429 13.1151 17.547 13.1105 17.5514 13.106Z"
													fill="#2AA797"
												/>
											</g>
											<defs>
												<clipPath id="clip0_1704:5240">
													<rect
														width="20"
														height="20"
														fill="white"
														transform="translate(0.667969)"
													/>
												</clipPath>
											</defs>
										</svg>
										<div
											class="text-neutral-500 text-sm ml-2"
										>
											Báo cáo hoàn thành
										</div>
									</div>
									<div
										class="flex items-center flex-nowrap justify-between"
									>
										<div
											class="text-neutral-600 font-bold text-4xl"
										>
											{{
												report.stats?.completed_count ||
												0
											}}
										</div>
									</div>
								</div>
								<div
									class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
								>
									<div class="flex items-center flex-nowrap">
										<svg
											width="21"
											height="20"
											viewBox="0 0 21 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g
												clip-path="url(#clip0_1704:5253)"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M2.83073 0C1.91025 0 1.16406 0.746192 1.16406 1.66667V18.3333C1.16406 19.2538 1.91026 20 2.83073 20H10.921C9.53699 18.7784 8.66406 16.9231 8.66406 14.9319C8.66406 11.25 11.6488 8.33333 15.3307 8.33333C16.2148 8.33333 17.0587 8.50542 17.8307 8.81793V1.66667C17.8307 0.746192 17.0845 0 16.1641 0H2.83073ZM2.83073 7.08333C2.60061 7.08333 2.41406 7.26988 2.41406 7.5C2.41406 7.73012 2.60061 7.91667 2.83073 7.91667H10.7474C10.9775 7.91667 11.1641 7.73012 11.1641 7.5C11.1641 7.26988 10.9775 7.08333 10.7474 7.08333H2.83073ZM2.83073 9.58333C2.60061 9.58333 2.41406 9.76988 2.41406 10C2.41406 10.2301 2.60061 10.4167 2.83073 10.4167H9.08073C9.31085 10.4167 9.4974 10.2301 9.4974 10C9.4974 9.76988 9.31085 9.58333 9.08073 9.58333H2.83073ZM2.83073 12.0833C2.60061 12.0833 2.41406 12.2699 2.41406 12.5C2.41406 12.7301 2.60061 12.9167 2.83073 12.9167H7.41406C7.64418 12.9167 7.83073 12.7301 7.83073 12.5C7.83073 12.2699 7.64418 12.0833 7.41406 12.0833H2.83073ZM2.83073 14.5833C2.60061 14.5833 2.41406 14.7699 2.41406 15C2.41406 15.2301 2.60061 15.4167 2.83073 15.4167H5.7474C5.97751 15.4167 6.16406 15.2301 6.16406 15C6.16406 14.7699 5.97751 14.5833 5.7474 14.5833H2.83073ZM3.2474 2.91667C2.78716 2.91667 2.41406 3.28976 2.41406 3.75C2.41406 4.21024 2.78716 4.58333 3.2474 4.58333H14.4974C14.9576 4.58333 15.3307 4.21024 15.3307 3.75C15.3307 3.28976 14.9576 2.91667 14.4974 2.91667H3.2474Z"
													fill="#94A3B8"
												/>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M20.3307 15C20.3307 17.7614 18.0922 20 15.3307 20C12.5693 20 10.3307 17.7614 10.3307 15C10.3307 12.2386 12.5693 10 15.3307 10C18.0922 10 20.3307 12.2386 20.3307 15ZM13.6767 12.904C13.5547 12.782 13.3568 12.782 13.2348 12.904C13.1127 13.0261 13.1127 13.2239 13.2348 13.346L14.8888 15L13.2348 16.654C13.1127 16.7761 13.1127 16.9739 13.2348 17.096C13.3568 17.218 13.5547 17.218 13.6767 17.096L15.3307 15.4419L16.9848 17.096C17.1068 17.218 17.3047 17.218 17.4267 17.096C17.5487 16.9739 17.5487 16.7761 17.4267 16.654L15.7727 15L17.4267 13.346C17.5487 13.2239 17.5487 13.0261 17.4267 12.904C17.3047 12.782 17.1068 12.782 16.9848 12.904L15.3307 14.5581L13.6767 12.904Z"
													fill="#94A3B8"
												/>
											</g>
											<defs>
												<clipPath id="clip0_1704:5253">
													<rect
														width="20"
														height="20"
														fill="white"
														transform="translate(0.332031)"
													/>
												</clipPath>
											</defs>
										</svg>
										<div
											class="text-neutral-500 text-sm ml-2"
										>
											Báo cáo chưa hoàn thành
										</div>
									</div>
									<div
										class="flex items-center flex-nowrap justify-between"
									>
										<div
											class="text-neutral-600 font-bold text-4xl"
										>
											{{
												report.stats
													?.incomplete_count || 0
											}}
										</div>
									</div>
								</div>
								<div
									class="bg-white p-4 rounded-xl border-sm shadow-sm flex items-center justify-between"
								>
									<div class="flex items-center flex-nowrap">
										<svg
											width="21"
											height="20"
											viewBox="0 0 21 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M13.1978 10.0001C13.1978 11.5821 11.9152 12.8647 10.3332 12.8647C8.7511 12.8647 7.46859 11.5821 7.46859 10.0001C7.46859 8.41802 8.7511 7.1355 10.3332 7.1355C11.9152 7.1355 13.1978 8.41802 13.1978 10.0001Z"
												fill="#2AA797"
											/>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M1.1665 10.0001C1.1665 10.0001 4.604 3.698 10.3332 3.698C16.0623 3.698 19.4998 10.0001 19.4998 10.0001C19.4998 10.0001 16.0623 16.3022 10.3332 16.3022C4.604 16.3022 1.1665 10.0001 1.1665 10.0001ZM10.3332 14.0105C12.5481 14.0105 14.3436 12.215 14.3436 10.0001C14.3436 7.78519 12.5481 5.98966 10.3332 5.98966C8.11828 5.98966 6.32275 7.78519 6.32275 10.0001C6.32275 12.215 8.11828 14.0105 10.3332 14.0105Z"
												fill="#2AA797"
											/>
										</svg>
										<div
											class="text-neutral-500 text-sm ml-2"
										>
											PH đã xem
										</div>
									</div>
									<div
										class="flex items-center flex-nowrap justify-between"
									>
										<div
											class="text-neutral-600 font-bold text-4xl"
										>
											{{
												report.stats
													?.numbers_of_parent_read_count ||
												0
											}}
										</div>
									</div>
								</div>
							</div>
							<div
								class="shadow-sm sm:rounded-2xl overflow-x-auto"
							>
								<div class="__record__table scroll-bar">
									<div
										class="sm:rounded-t-2xl w-fit min-w-full"
									>
										<table
											class="min-w-full divide-y text-neutral-200"
										>
											<thead class="bg-neutral-100 h-16">
												<tr>
													<th
														scope="col"
														class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
													>
														STT
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-32 whitespace-nowrap"
													>
														Tên học sinh
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
													>
														Lớp Bán trú
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
													>
														Sức khoẻ
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
													>
														Giấc ngủ
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
													>
														Ăn uống
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
													>
														Trạng thái
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
													>
														nhận xét buổi học
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
													>
														cảm xúc
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
													>
														điểm danh
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
													>
														Gửi tới PH
													</th>
													<th
														scope="col"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider"
													>
														PH ĐÃ XEM
													</th>
													<th
														scope="col"
														class="px-3 py-3 w-12 tracking-wider whitespace-nowrap"
													></th>
												</tr>
											</thead>
											<tbody>
												<tr
													@click="
														item.state !==
															'created' &&
															$router.push(
																`/report/day-care/${report.date}?student_id=${item?.student?.id}`
															)
													"
													v-for="(
														item, index
													) in report.data"
													:key="item.id"
													:class="[
														index % 2 === 0
															? 'bg-white'
															: 'bg-neutral-50',
														item.state !== 'created'
															? 'cursor-pointer'
															: '',
													]"
													class="text-neutral-700 hover:bg-orange-50 cursor-pointer"
												>
													<td>
														<div
															class="px-3 py-4 text-center text-neutral-700"
														>
															{{ index + 1 }}
														</div>
													</td>
													<td
														class="px-3 py-4 whitespace-nowrap text-neutral-700"
													>
														<div
															style="width: 200px"
															class="flex items-center cursor-pointer"
														>
															<img
																class="shadow-sm inline-block h-6 w-6 rounded-full"
																:src="
																	item
																		?.student
																		?.profile_photo
																		?.w200
																"
																v-if="
																	item
																		?.student
																		?.profile_photo
																		?.w200
																"
																alt=""
															/>
															<span
																v-else
																class="inline-flex items-center justify-center h-6 w-6 rounded-full"
																:style="{
																	background:
																		item
																			?.student
																			?.profile_photo
																			?.default
																			?.color,
																}"
															>
																<span
																	class="text-xs font-medium leading-none text-white"
																	>{{
																		item
																			?.student
																			?.profile_photo
																			?.default
																			?.initial
																	}}</span
																>
															</span>
															<div
																class="ml-4 font-semibold text-orange-600"
															>
																{{
																	item
																		?.student
																		?.name
																}}
															</div>
														</div>
													</td>
													<td>
														<div class="px-3 py-4">
															{{
																item?.dayCareClass
															}}
														</div>
													</td>
													<td>
														<div
															style="width: 100px"
															class="px-3 py-4 capitalize whitespace-nowrap"
															:class="{
																'text-red-500':
																	item?.day_care_health ===
																	'unwell',
															}"
														>
															{{
																item?.translated_day_care_health
															}}
														</div>
													</td>
													<td>
														<div
															style="width: 100px"
															class="px-3 py-4 capitalize whitespace-nowrap"
															:class="{
																'text-red-500':
																	item?.day_care_sleep ===
																	'none',
															}"
														>
															{{
																item?.translated_day_care_sleep
															}}
														</div>
													</td>
													<td>
														<div
															class="px-3 py-4 capitalize whitespace-nowrap"
														>
															<div
																v-if="
																	enabledMenu
																"
															>
																<div
																	v-for="meal in item?.day_care_eats"
																	:key="
																		meal.id
																	"
																>
																	{{
																		meal.meal_name
																	}}:
																	{{
																		meal.translated_day_care_eat
																	}}
																</div>
															</div>
															<div
																v-else
																:class="{
																	'text-red-500':
																		item?.day_care_sleep ===
																		'none',
																}"
															>
																{{
																	item?.translated_day_care_eat
																}}
															</div>
														</div>
													</td>
													<td
														class="px-3 py-4 whitespace-nowrap text-neutral-700"
													>
														<div class="ml-6">
															<svg
																width="21"
																height="20"
																viewBox="0 0 21 20"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
																v-if="
																	item?.state ===
																	'completed'
																"
															>
																<g
																	clip-path="url(#clip0_1706:5649)"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M1.5 1.66667C1.5 0.746192 2.2397 0 3.15217 0H16.3696C17.282 0 18.0217 0.746192 18.0217 1.66667V8.81793C17.2564 8.50542 16.4199 8.33333 15.5435 8.33333C11.8936 8.33333 8.93478 11.25 8.93478 14.9319C8.93478 16.9231 9.80012 18.7784 11.1721 20H3.15217C2.2397 20 1.5 19.2538 1.5 18.3333V1.66667ZM2.73913 7.5C2.73913 7.26988 2.92406 7.08333 3.15217 7.08333H11C11.2281 7.08333 11.413 7.26988 11.413 7.5C11.413 7.73012 11.2281 7.91667 11 7.91667H3.15217C2.92406 7.91667 2.73913 7.73012 2.73913 7.5ZM2.73913 10C2.73913 9.76988 2.92406 9.58333 3.15217 9.58333H9.34783C9.57594 9.58333 9.76087 9.76988 9.76087 10C9.76087 10.2301 9.57594 10.4167 9.34783 10.4167H3.15217C2.92406 10.4167 2.73913 10.2301 2.73913 10ZM2.73913 12.5C2.73913 12.2699 2.92406 12.0833 3.15217 12.0833H7.69565C7.92377 12.0833 8.1087 12.2699 8.1087 12.5C8.1087 12.7301 7.92377 12.9167 7.69565 12.9167H3.15217C2.92406 12.9167 2.73913 12.7301 2.73913 12.5ZM2.73913 15C2.73913 14.7699 2.92406 14.5833 3.15217 14.5833H6.04348C6.2716 14.5833 6.45652 14.7699 6.45652 15C6.45652 15.2301 6.2716 15.4167 6.04348 15.4167H3.15217C2.92406 15.4167 2.73913 15.2301 2.73913 15ZM2.73913 3.75C2.73913 3.28976 3.10898 2.91667 3.56522 2.91667H14.7174C15.1736 2.91667 15.5435 3.28976 15.5435 3.75C15.5435 4.21024 15.1736 4.58333 14.7174 4.58333H3.56522C3.10898 4.58333 2.73913 4.21024 2.73913 3.75Z"
																		fill="#2AA797"
																	/>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M15.5435 20C18.2809 20 20.5 17.7614 20.5 15C20.5 12.2386 18.2809 10 15.5435 10C12.8061 10 10.587 12.2386 10.587 15C10.587 17.7614 12.8061 20 15.5435 20ZM17.3834 13.106C17.5649 12.923 17.8591 12.923 18.0405 13.106C18.2198 13.2869 18.222 13.5786 18.0471 13.7622L15.5737 16.8811C15.5701 16.8856 15.5663 16.8899 15.5623 16.894C15.3808 17.077 15.0866 17.077 14.9051 16.894L13.2655 15.2399C13.084 15.0569 13.084 14.7601 13.2655 14.577C13.4469 14.394 13.7412 14.394 13.9226 14.577L15.2197 15.8855L17.3711 13.1201C17.3749 13.1151 17.379 13.1105 17.3834 13.106Z"
																		fill="#2AA797"
																	/>
																</g>
																<defs>
																	<clipPath
																		id="clip0_1706:5649"
																	>
																		<rect
																			width="20"
																			height="20"
																			fill="white"
																			transform="translate(0.5)"
																		/>
																	</clipPath>
																</defs>
															</svg>
															<svg
																width="21"
																height="20"
																viewBox="0 0 21 20"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
																v-else
															>
																<g
																	clip-path="url(#clip0_1739:6086)"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M2.9987 0C2.07822 0 1.33203 0.746192 1.33203 1.66667V18.3333C1.33203 19.2538 2.07822 20 2.9987 20H11.089C9.70496 18.7784 8.83203 16.9231 8.83203 14.9319C8.83203 11.25 11.8168 8.33333 15.4987 8.33333C16.3828 8.33333 17.2267 8.50542 17.9987 8.81793V1.66667C17.9987 0.746192 17.2525 0 16.332 0H2.9987ZM2.9987 7.08333C2.76858 7.08333 2.58203 7.26988 2.58203 7.5C2.58203 7.73012 2.76858 7.91667 2.9987 7.91667H10.9154C11.1455 7.91667 11.332 7.73012 11.332 7.5C11.332 7.26988 11.1455 7.08333 10.9154 7.08333H2.9987ZM2.9987 9.58333C2.76858 9.58333 2.58203 9.76988 2.58203 10C2.58203 10.2301 2.76858 10.4167 2.9987 10.4167H9.2487C9.47882 10.4167 9.66536 10.2301 9.66536 10C9.66536 9.76988 9.47882 9.58333 9.2487 9.58333H2.9987ZM2.9987 12.0833C2.76858 12.0833 2.58203 12.2699 2.58203 12.5C2.58203 12.7301 2.76858 12.9167 2.9987 12.9167H7.58203C7.81215 12.9167 7.9987 12.7301 7.9987 12.5C7.9987 12.2699 7.81215 12.0833 7.58203 12.0833H2.9987ZM2.9987 14.5833C2.76858 14.5833 2.58203 14.7699 2.58203 15C2.58203 15.2301 2.76858 15.4167 2.9987 15.4167H5.91536C6.14548 15.4167 6.33203 15.2301 6.33203 15C6.33203 14.7699 6.14548 14.5833 5.91536 14.5833H2.9987ZM3.41536 2.91667C2.95513 2.91667 2.58203 3.28976 2.58203 3.75C2.58203 4.21024 2.95513 4.58333 3.41536 4.58333H14.6654C15.1256 4.58333 15.4987 4.21024 15.4987 3.75C15.4987 3.28976 15.1256 2.91667 14.6654 2.91667H3.41536Z"
																		fill="#94A3B8"
																	/>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M20.4987 15C20.4987 17.7614 18.2601 20 15.4987 20C12.7373 20 10.4987 17.7614 10.4987 15C10.4987 12.2386 12.7373 10 15.4987 10C18.2601 10 20.4987 12.2386 20.4987 15ZM13.8447 12.904C13.7226 12.782 13.5248 12.782 13.4027 12.904C13.2807 13.0261 13.2807 13.2239 13.4027 13.346L15.0568 15L13.4027 16.654C13.2807 16.7761 13.2807 16.9739 13.4027 17.096C13.5248 17.218 13.7226 17.218 13.8447 17.096L15.4987 15.4419L17.1527 17.096C17.2748 17.218 17.4726 17.218 17.5947 17.096C17.7167 16.9739 17.7167 16.7761 17.5947 16.654L15.9406 15L17.5947 13.346C17.7167 13.2239 17.7167 13.0261 17.5947 12.904C17.4726 12.782 17.2748 12.782 17.1527 12.904L15.4987 14.5581L13.8447 12.904Z"
																		fill="#94A3B8"
																	/>
																</g>
																<defs>
																	<clipPath
																		id="clip0_1739:6086"
																	>
																		<rect
																			width="20"
																			height="20"
																			fill="white"
																			transform="translate(0.5)"
																		/>
																	</clipPath>
																</defs>
															</svg>
														</div>
													</td>
													<td>
														<div
															class="px-3 py-4"
															style="
																max-width: 140px;
																margin-right: 40px;
															"
														>
															<Rating
																:rating="
																	item?.day_care_scale
																"
															/>
														</div>
													</td>
													<td>
														<div class="px-3 py-4">
															<img
																v-if="
																	item?.emotion_scale
																"
																:src="
																	require(`@/assets/images/emoji/${
																		$filters.emoji(
																			item?.emotion_scale +
																				''
																		).emoji
																	}`)
																"
																alt=""
																class="h-6 w-6"
															/>
														</div>
													</td>
													<td
														style="min-width: 115px"
														class="px-3 py-4 capitalize whitespace-nowrap"
													>
														<div
															class="flex items-center gap-2"
														>
															<img
																v-if="
																	item
																		?.checkin
																		?.display_time
																"
																src="@/assets/images/icons/checkin.png"
																alt=""
															/>
															<img
																v-else
																src="@/assets/images/icons/disabled-checkin.png"
																alt=""
															/>
															<div
																v-if="
																	item
																		?.checkin
																		?.display_time
																"
															>
																{{
																	item
																		?.checkin
																		?.display_time
																}}
															</div>
															<div v-else>-</div>
															<img
																v-if="
																	item
																		?.checkin
																		?.sent_at
																"
																src="@/assets/images/icons/has_taught.png"
																alt=""
															/>
														</div>
														<div
															class="flex items-center gap-2"
														>
															<img
																v-if="
																	item
																		?.checkout
																		?.display_time
																"
																src="@/assets/images/icons/checkout.png"
																alt=""
															/>
															<img
																v-else
																src="@/assets/images/icons/disabled-checkout.png"
																alt=""
															/>
															<div
																v-if="
																	item
																		?.checkout
																		?.display_time
																"
															>
																{{
																	item
																		?.checkout
																		?.display_time
																}}
															</div>
															<div v-else>-</div>
															<img
																v-if="
																	item
																		?.checkout
																		?.sent_at
																"
																src="@/assets/images/icons/has_taught.png"
																alt=""
															/>
														</div>
													</td>
													<td
														class="px-3 py-4 whitespace-nowrap text-neutral-700"
													>
														<button
															v-if="
																item.state ===
																	'completed' &&
																!item.sent_at &&
																!org?.enable_day_care_report_sent
															"
															@click.stop="
																sendReport(item)
															"
															type="button"
															class="button-p text-center whitespace-nowrap w-fit btn--ghost"
														>
															Gửi báo cáo
														</button>
														<span v-else>
															{{
																item.sent_at
																	? 'Đã gửi'
																	: '-'
															}}
														</span>
													</td>
													<td>
														<div
															style="width: 100px"
															class="px-3 py-4 capitalize whitespace-nowrap"
														>
															{{
																item.numbers_of_parent_read ||
																0
															}}/
															{{
																item.total_parent_count ||
																0
															}}
														</div>
													</td>
													<td class="w-12 px-3 py-4">
														<Menu
															v-if="
																((item?.checkin &&
																	!item
																		?.checkin
																		.sent_at) ||
																	(item?.checkout &&
																		!item
																			?.checkout
																			?.sent_at)) &&
																flagCheck() &&
																enableStaffSendAttendanceTrack
															"
															as="div"
															class="relative"
														>
															<div>
																<MenuButton
																	@click.stop="
																		setReportMenuPosition
																	"
																	class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
																>
																	<span
																		class="sr-only"
																		>Open
																		user
																		menu</span
																	>
																	<svg
																		width="20"
																		height="20"
																		viewBox="0 0 20 20"
																		fill="none"
																		xmlns="http://www.w3.org/2000/svg"
																	>
																		<path
																			fill-rule="evenodd"
																			clip-rule="evenodd"
																			d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
																			fill="#94A3B8"
																		/>
																	</svg>
																</MenuButton>
															</div>
															<teleport to="body">
																<transition
																	enter-active-class="transition ease-out duration-200"
																	enter-from-class="transform opacity-0 scale-95"
																	enter-to-class="transform opacity-100 scale-100"
																	leave-active-class="transition ease-in duration-75"
																	leave-from-class="transform opacity-100 scale-100"
																	leave-to-class="transform opacity-0 scale-95"
																>
																	<MenuItems
																		:style="
																			reportMenuStyle
																		"
																		class="origin-top-right fixed z-50 w-80 rounded-md py-1 bg-white focus:outline-none shadow-sm"
																	>
																		<MenuItem>
																			<div
																				class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
																				@click.stop="
																					openSendData(
																						item
																					)
																				"
																			>
																				<img
																					src="@/assets/images/icons/send.png"
																					alt=""
																				/>
																				<div>
																					Gửi
																					điểm
																					danh
																					tới
																					PH
																				</div>
																			</div>
																		</MenuItem>
																	</MenuItems>
																</transition>
															</teleport>
														</Menu>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<DaInfinityLoading
					@infinite-load="listDayCareReport"
					:loaded="stopLoad"
					v-if="isInfinityLoading"
					:is-loading="isLoading"
				/>
			</div>
			<div
				v-else
				class="w-full h-full flex items-center justify-center flex-col mt-20"
			>
				<img
					src="@/assets/images/illustrations/not_found.png"
					alt=""
					height="250"
					width="250"
				/>
				<div class="text-neutral-500 text-lg max-w-lg text-center">
					Cơ sở chưa có báo cáo bán trú nào. Dùng app
					{{ $filters.terminology('teacher') }} để báo cáo kết quả học
					bán trú hàng ngày của học sinh.
				</div>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script>
import Rating from '@/components/elements/rating/Rating.vue';
import { Options, Vue, setup } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import SideOver from '@/components/elements/sideOver/SideOver.vue';
import { useStore } from 'vuex';
import dayjs from 'dayjs';
import DaInfinityLoading from '@/components/common/daInfinityLoading/DaInfinityLoading.vue';
import { useGetEmployees } from '@/views/record/employee/services/getEmployees';
import { useStudent } from '@/features/student/useStudent';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { useListDayCareReport } from '@/features/lessonReport/listDayCareReport';
import Loading from '@/components/common/Loading.vue';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import DeleteConfirmModal from '@/views/report/features/dayCareClasses/DeleteConfirm.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import { $api } from '@/services';
import { FLAG_CHECK } from '@/helper/flagCheck';
import SendData from '@/views/report/features/lesson/SendData.vue';

@Options({
	name: 'DayCareClasses',
	components: {
		SendData,
		DaModalFrame,
		DeleteConfirmModal,
		Loading,
		DaInfinityLoading,
		SideOver,
		Rating,
		DaIcon,
		Menu,
		MenuButton,
		MenuItem,
		MenuItems,
	},
})
export default class DayCareClasses extends Vue {
	sideOverShow = false;
	filter = null;
	type = '';
	dataProps = null;
	lessonReports = [];
	dateNow = new Date();
	dateFilter = '';
	before = null;
	isFilterDate = false;
	stopLoad = false;
	staffs = [];
	students = [];
	isInfinityLoading = true;
	isLoading = true;
	alertShow = true;
	modalIsOpen = false;
	dataDelete = null;
	isHides = [];
	reportMenuStyle = {};

	//----------------------- 🤍 Setup 🤍 -----------------------//
	setup = setup(() => {
		const store = useStore();
		const { getStudents } = useStudent();
		const { getEmployees } = useGetEmployees();
		const { listDayCareReport } = useListDayCareReport();
		return {
			getEmployees,
			getStudents,
			listDayCareReport,
			store,
		};
	});

	get isAdmin() {
		return this.setup.store.getters.isAdmin;
	}

	get store() {
		return this.setup.store;
	}

	get org() {
		return this.setup.store.state.profile.current_org;
	}

	get has_day_care() {
		return this.setup.store.state.profile.current_org?.has_day_care;
	}

	get enableStaffSendAttendanceTrack() {
		return this.setup.store.state.profile.current_org
			.enable_staff_send_day_care_attendance_track;
	}

	get enabledMenu() {
		return this.setup.store.state.profile.current_org.enabled_menu;
	}

	//----------------------- 🤍 Created 🤍 -----------------------//
	created() {
		if (!this.has_day_care) {
			this.$router.push('/');
		}
		const q = this.$route.query;
		this.dateFilter = q.date ? dayjs(q.date).format('DD/MM/YYYY') : '';
		this.listDayCareReport();
		this.search();
		this.fetchStudents();
	}

	//----------------------- 🤍 Watch 🤍 -----------------------//
	@Watch('$route')
	onRouterChange(value) {
		if (value?.name === 'report_day-care') {
			this.lessonReports = [];
			this.listDayCareReport();
		}
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//

	flagCheck() {
		return FLAG_CHECK('DAYCARE_ATTENDANCE');
	}

	async listDayCareReport() {
		const q = this.$route.query;
		const res = await this.setup.listDayCareReport(
			q,
			this.before,
			!this.isAdmin
		);
		if (res?.data?.length > 0 || (res?.data?.length === 0 && res?.date)) {
			let day_care_classes = res?.day_care_classes || [];
			// @ts-ignore
			this.lessonReports.push({
				date: res?.date,
				data: this.getClassDayCare(res?.data, day_care_classes),
				stats: res?.stats,
				cancelled_stats: res?.cancelled_stats,
			});
			this.before = res?.date;
		} else if (res?.data?.length === 0 && res?.date === null) {
			this.stopLoad = true;
		}

		this.isLoading = false;
	}

	async search() {
		const res = await this.setup.getEmployees('');
		this.staffs = res?.data || [];
	}

	async fetchStudents() {
		let role =
			this.store.state.profile.staff.role === 'teacher'
				? 'staff'
				: 'org_admin';
		const studentList = await this.setup.getStudents(role, {});
		this.students = studentList.data;
	}

	getClassDayCare(array, day_care_classes) {
		return array.map((item) => {
			let dayCare = day_care_classes.find(
				(element) => element.id === item.day_care_class_id
			);
			return {
				...item,
				dayCareClass: dayCare?.name,
			};
		});
	}

	studentById(id) {
		return this.students.find((item) => item.id === id);
	}

	staffById(id) {
		return this.staffs.find((item) => item.id === id);
	}

	clean(obj) {
		for (let propName in obj) {
			if (
				obj[propName] === null ||
				obj[propName] === undefined ||
				obj[propName].length <= 0
			) {
				delete obj[propName];
			}
		}
		return obj;
	}

	filterSubmit(queryPa) {
		this.before = null;
		if (!queryPa) {
			this.dateFilter = dayjs(this.dateNow).format('DD/MM/YYYY');
			this.filter = null;
			this.$router.push('');
		} else {
			this.filter = {
				...this.filter,
				...queryPa,
			};
			this.clean(this.filter);
			const query = Object.keys(this.filter)
				.map((key) => `${key}=${this.filter[key]}`)
				.join('&');
			this.$router.push(`?${query}`);
		}
		this.sideOverShow = false;
	}

	showHide(date) {
		const index = this.isHides.indexOf(date);
		if (index !== -1) {
			this.isHides.splice(index, 1);
		} else {
			this.isHides.push(date);
		}
	}

	openDeleteConfirm(data) {
		this.dataDelete = data;
		this.type = 'delete';
		this.modalIsOpen = true;
	}

	closeModal() {
		this.dataDelete = null;
		this.dataProps = null;
		this.type = '';
		this.modalIsOpen = false;
	}

	async success() {
		this.closeModal();
		this.before = null;
		this.lessonReports = [];
		await this.listDayCareReport();
	}

	async sendReport(item) {
		try {
			await $api.lessonReport.sendDaycareReport(item?.id);
			this.closeModal();
			await this.store.dispatch('setAlertMessage', {
				message: 'Báo cáo đã được gửi thành công đến phụ huynh.',
			});
			item.sent_at = new Date();
		} catch (err) {
			await this.store.dispatch('setAlertMessage', {
				message:
					err?.response?.data?.errors?.join('<br/>') ||
					'Đã có lỗi xảy ra. Vui lòng thử lại',
				type: 'danger',
			});
		}
	}

	async recoverReport(id) {
		try {
			const res = await $api.lessonReport.recoverReport(id);
			if (res.data) {
				await this.store.dispatch('setAlertMessage', {
					message: 'Khôi phục báo cáo thành công',
				});
			}
		} catch (err) {
			await this.store.dispatch('setAlertMessage', {
				message:
					err?.response?.data?.errors?.join('<br/>') ||
					'Đã có lỗi xảy ra. Vui lòng thử lại',
				type: 'danger',
			});
		}
	}

	openSendData(data) {
		this.dataProps = data;
		this.type = 'send';
		this.modalIsOpen = true;
	}

	setReportMenuPosition(event) {
		const rect = event.currentTarget.getBoundingClientRect();
		this.reportMenuStyle = {
			top: `${rect.bottom + 8}px`,
			right: `${window.innerWidth - rect.right}px`,
		};
	}

	beforeDestroy() {
		this.isInfinityLoading = false;
	}
}
</script>

<style scoped>
.grid-cols-3 {
	grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
</style>
